import axios from "axios";
import { adminSlice } from "../reducers/AdminSlice";
import { AppDispatch } from "../Store";
import {
  CREATE_ORGANIZATION,
  CREATE_USER,
  GET_ALL_ORGANIZATIONS,
  GET_ALL_USERS,
} from "./endpoints";
import { ICreateAdminUser, ICreateOrganization } from "../types/AdminTypes";

export const getAllUsers = () => async (dispatch: AppDispatch) => {
  try {
    dispatch(adminSlice.actions.getAllUsersLoading());
    const jwt = localStorage.getItem("jwt");
    if (!jwt) return false;
    const res = await axios.get(GET_ALL_USERS, {
      headers: {
        authorization: `Bearer ${jwt}`,
      },
    });
    dispatch(adminSlice.actions.getAllUsersSuccess(res.data));
    return res.data;
  } catch (error: any) {
    console.log(error);
    dispatch(adminSlice.actions.getAllUsersFailed(error.message));
    return false;
  }
};

export const createUser =
  (data: ICreateAdminUser) => async (dispatch: AppDispatch) => {
    try {
      dispatch(adminSlice.actions.createUserLoading());
      const jwt = localStorage.getItem("jwt");
      if (!jwt) return false;
      const res = await axios.post(CREATE_USER, data, {
        headers: {
          authorization: `Bearer ${jwt}`,
        },
      });
      dispatch(adminSlice.actions.createUserSuccess(res.data));
      return res.data;
    } catch (error: any) {
      console.log(error);
      dispatch(adminSlice.actions.createUserFailed(error.message));
      return false;
    }
  };

export const getAllOrganizations = () => async (dispatch: AppDispatch) => {
  try {
    dispatch(adminSlice.actions.getAllOrganizationsLoading());
    const jwt = localStorage.getItem("jwt");
    if (!jwt) return false;
    const res = await axios.get(GET_ALL_ORGANIZATIONS, {
      headers: {
        authorization: `Bearer ${jwt}`,
      },
    });
    dispatch(adminSlice.actions.getAllOrganizationsSuccess(res.data));
    return res.data;
  } catch (error: any) {
    console.log(error);
    dispatch(adminSlice.actions.getAllOrganizationsFailed(error.message));
    return false;
  }
};

export const createOrganization =
  (data: ICreateOrganization) => async (dispatch: AppDispatch) => {
    try {
      dispatch(adminSlice.actions.createOrganizationLoading());
      const jwt = localStorage.getItem("jwt");
      if (!jwt) return false;
      const res = await axios.post(CREATE_ORGANIZATION, data, {
        headers: {
          authorization: `Bearer ${jwt}`,
        },
      });
      dispatch(adminSlice.actions.createOrganizationSuccess(res.data));
      return res.data;
    } catch (error: any) {
      console.log(error);
      dispatch(adminSlice.actions.createOrganizationFailed(error.message));
      return false;
    }
  };
